"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrePredictionSystemDecorationBusinessTask = exports.case88 = exports.case87 = exports.case86 = exports.case85 = exports.case84 = exports.case83 = exports.case82 = exports.case81 = exports.case80 = exports.case79 = void 0;
var case_79_json_1 = __importDefault(require("./case_79.json"));
exports.case79 = case_79_json_1.default;
var case_80_json_1 = __importDefault(require("./case_80.json"));
exports.case80 = case_80_json_1.default;
var case_81_json_1 = __importDefault(require("./case_81.json"));
exports.case81 = case_81_json_1.default;
var case_82_json_1 = __importDefault(require("./case_82.json"));
exports.case82 = case_82_json_1.default;
var case_83_json_1 = __importDefault(require("./case_83.json"));
exports.case83 = case_83_json_1.default;
var case_84_json_1 = __importDefault(require("./case_84.json"));
exports.case84 = case_84_json_1.default;
var case_85_json_1 = __importDefault(require("./case_85.json"));
exports.case85 = case_85_json_1.default;
var case_86_json_1 = __importDefault(require("./case_86.json"));
exports.case86 = case_86_json_1.default;
var case_87_json_1 = __importDefault(require("./case_87.json"));
exports.case87 = case_87_json_1.default;
var case_88_json_1 = __importDefault(require("./case_88.json"));
exports.case88 = case_88_json_1.default;
var pre_prediction_activity_json_1 = __importDefault(require("./pre-prediction.activity.json"));
exports.PrePredictionSystemDecorationBusinessTask = pre_prediction_activity_json_1.default;
//# sourceMappingURL=library.js.map